import { IResourceDto } from "@models/storage/ResourceDto";
import { fileTypeFromBlob } from "file-type";
import { basename, extname } from "path-browserify";
import { v4 as uuidv4 } from "uuid";

export const apiStorageToDto = (url: string): IResourceDto => {
  const parsedUrl = new URL(url);

  return {
    mediaLink: `${parsedUrl.origin}${parsedUrl.pathname}`,
  };
};

export const getExtension = (fileLink: string) => extname(fileLink);

export const getFileNameWithoutExtension = (filePath: string): string => {
  const extension = extname(filePath);
  return basename(filePath, extension);
};

export const isCsvFile = (fileLink: string) =>
  getExtension(fileLink) === ".csv";

export const checkSizeFile = (sizeTocheck: number, maxSize?: number) =>
  maxSize ? sizeTocheck > maxSize : false;

export const generateNameFile = async (
  file: File,
  newName?: string
): Promise<string> => {
  const name = newName ?? uuidv4();

  // Try to get the extension from the mime type
  const fileType = await fileTypeFromBlob(file);
  if (fileType) {
    return `${name}.${fileType.ext}`;
  }

  // Otherwise get it from the name of the file
  return `${name}${getExtension(file.name)}`;
};

export const getNameFileFromLink = (fileLink: string) => {
  try {
    const parse = fileLink.split("/");
    const mediaName = parse[parse.length - 1];

    return mediaName ? mediaName : undefined;
  } catch (error) {
    return;
  }
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return "0 B";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
